<div class="mobile-section">
  <div class="mobile-shell">

    <!-- Left: copy -->
    <div class="mobile-copy">
      <p class="mobile-label">Follow Up From Anywhere</p>
      <h2 class="mobile-heading">
        Never Miss a <span class="mobile-heading--highlight">Beat</span>,<br />On the Go
      </h2>
      <p class="mobile-desc">
        New leads, deals about to close, and follow-ups that are due — pushed straight to your
        phone the moment they happen, so your pipeline keeps moving even when you're away from your desk.
      </p>
    </div>

    <!-- Right: animated phone with notification stack -->
    <div class="mobile-visual" aria-hidden="true">
      <div class="phone-frame">
        <div class="phone-notch"></div>
        <div class="phone-screen">
          <div class="notification-card" *ngFor="let n of notifications; let i = index" [style.animation-delay.s]="i * 1.2">
            <span class="notification-icon">{{ n.icon }}</span>
            <div class="notification-body">
              <span class="notification-title">{{ n.title }}</span>
              <span class="notification-desc">{{ n.desc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
